import RugCardDetailedInformation from './RugCardDetailedInformation'
export default RugCardDetailedInformation
